// LLM generated - Model Claude 4 Sonnet

type CurrencyFormatResult = {
    /** Dollar amount as string (e.g., "1,000") */
    dollars: string;
    /** Cents amount as string (e.g., "94") */
    cents: string;
}

const useBalanceWidget = () => {
  /**
   * Formats a currency amount into dollars and cents
   * @param amount - The amount to format
   * @returns Object with formatted dollars and cents
   */
  const formatCurrency = (amount: number): CurrencyFormatResult => {
    // Handle edge cases
    if (Number.isNaN(amount) || amount < 0) {
      return { dollars: '0', cents: '00' };
    }

    // Split into dollars and cents
    const dollars = Math.floor(amount);
    const cents = Math.round((amount - dollars) * 100);

    // Format dollars with commas
    const formattedDollars = dollars.toLocaleString('en-US');

    // Ensure cents are always two digits
    const formattedCents = cents.toString().padStart(2, '0');

    return {
      dollars: formattedDollars,
      cents: formattedCents,
    };
  };

  return {
    formatCurrency,
  };
};

export default useBalanceWidget;
